import type { Color } from "@deck.gl/core";

export const TRANSPARENT: Color = [0, 0, 0, 0];
export const SHARED_SITE_COLOR: Color = [1, 235, 199];

export const VISIBLE = 1;
export const HIDDEN = -1;
